module.exports = __webpack_public_path__ + "908e4d2e/img/note-list-icon.961c1485.svg";